import React from 'react';
import { useController } from 'react-hook-form';
import { Box } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import PropTypes from 'prop-types';
import Typography from '../common/Typography.component';

const ViewMexalValidation = ({ name = '', value }) => {

  const {
    field: {...inputProps },
  } = useController({
    name: name,
  });
  
  return (
        <Box sx={{pt:1}}>
            {(inputProps.value !== true) || (value) ? 
             <Typography variant='body1' sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                    Mexal Validation: <CancelIcon color='error' />
            </Typography> : null}
        </Box>
  );
};

ViewMexalValidation.propTypes = {
  name: PropTypes.string,
};

export default ViewMexalValidation;
